/**
 * Provide the Geo location (latitude, longitude) from city state name
 * Google API is used to search the location
 *@param {*} {string} postal code
 * @returns geo coordinates (latitude, longitude)
 */
export function getGeoCoderLatLong(cityState : string) {
    return new Promise(function (resolve : any, reject : any) {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            'address': cityState
        }, function (results, status) {
            if (status == 'OK') {
                resolve(results[0].geometry.location.toJSON());
            } else {
                reject(status);
            }
        });
    });
}